export const USER_LOGIN = "/authentication/login";
export const VALIDATE_RECAPTCHA = "/authentication/recaptcha";
export const USER_LOGOUT = "/authentication/logout";
export const USER_FORGOT_PASSWORD = "/authentication/forgotpassword";
export const USER_UPDATE_PASSWORD = "/authentication/updatepassword";
export const GET_ACCESS_TOKEN_FROM_REFRESH_TOKEN =
  "/authentication/refreshtoken";
export const GET_USER_PROFILE = "/authentication/userprofile";
export const GET_USER_PROFILES = "/authentication/getuserprofiles";
export const UPDATE_I9_STATUS = "/employee/updatei9status";

export const CREATE_COMPANY = "/company/addcompanies";
export const GET_COMPANIES_LIST = "/company/getallcompanies";
export const UPDATE_COMPANY_STATUS = "company/updatecompanystatus";
export const UPDATE_COMPANY = "company/updatecompany";
export const DELETE_COMPANY = "company/deletecompany";
export const GET_COMPANY_HIERARCHY = "company/gethierarchy";

export const CREATE_USER = "/user/invitenewuser";
export const GET_USERS_LIST = "/user/getallusers";
export const UPDATE_USER_STATUS = "User/updateuserstatus";
export const UPDATE_USER = "user/updateuser";
export const DELETE_USER = "user/deleteuser";

export const GET_EMPLOYEES_LIST = "employee/getemployees";
export const ADD_EMPLOYEE_BASIC_DETAILS = "employee/adddetails";
export const ADD_EMPLOYEE_I9_SECTION2 = "employee/addemployee";
export const UPDATE_EMPLOYEE_BASIC_DETAILS = "employee/updatedetails";
export const UPDATE_EMPLOYEE = "employee/updateemployee";
export const GET_EMPLOYEE_BASIC_DETAILS = "employee/getdetails";
export const GET_EMPLOYEE_AUDIT_LIST = ""
export const GET_I9_PRIOR = "i9form/getprior";
export const UPDATE_EMPLOYEE_TRANSACTION_STATUS =
  "i9form/updatetransactionstatustostarted";
export const GET_PRIOR = "i9form/getprior";
export const GET_EMPLOYEE_I9_DETAILS = "i9form/getdetails";
export const DELETE_EMPLOYEE_I9_DOCUMENT = "i9form/document";
export const GET_EMPLOYEE_TRANSACTION_STATUS = "employee/status";
export const UPSERT_EMPLOYEE_I9_DETAILS = "i9form/upsertdetails";
export const GET_EMPLOYEE_I9_FORM = "i9form/generatepdf";
export const GET_EMPLOYEE_I9_HTML = "i9form/generatehtml";
export const GENERATE_AND_SAVE_I9_PDF = "i9form/generateandsavepdf";
export const GET_I9_PDF_SAS_URL = "i9form/getpdfsasurl";
export const AUTOFILL_I9_WITH_DOCUMENT = "i9form/analyzedocument";
export const GET_EVERIFY_EMPLOYEES = "everify/geteverifyemployees";
export const EVERIFY_CASE_FIELDS = "everify/casefields";
export const EVERIFY_CREATE_CASE = "everify/createcasewithi9";
export const EVERIFY_DUPLICATE_CHECK = "everify/duplicatecheck";

export const GET_COMPANY_STATUS_LINKS = "dashboard/getcompanylinksandstatus";
export const GET_I9_FORM_DOCUMENTSLIST = "dashboard/getalllisteddocuments";
export const GET_AUDIT_LOGS = "dashboard/audit";
export const POST_USER_SUPPORT = "dashboard/addsupport";

export const VERIFICATION_SLOTS = "verification/slots";
export const VERIFICATION_SLOTS_SEARCH = "verification/slots/search";
export const VERIFICATION_BOOK = "verification/book";

export const VERIFICATION_SESSIONS = "verification/sessions";
export const VERIFICATION_SCHEDULE = "verification/schedule";

export const VERIFICATION_RULES = "verification/rules";
export const VERIFICATION_BLACKOUTS = "verification/blackouts";

export const VERIFICATION_CONSENT_TEXT = "verification/consent/text";
export const VERIFICATION_CONSENT = "verification/consent";

export const VERIFICATION_CALENDAR_AUTH_URL = "verification/calendar"; 
export const VERIFICATION_CALENDAR_STATUS = "verification/calendar/status";
export const VERIFICATION_CALENDAR = "verification/calendar"; 
export const VERIFICATION_CALENDAR_FREEBUSY = "verification/calendar/freebusy";

export const I9AUDIT_START = "i9audit/start";
export const I9AUDIT_RUNS = "i9audit/runs";
export const I9AUDIT_RUN_FILTERS = "i9audit/runfilters";
export const I9AUDIT_RUN = "i9audit/run";
export const I9AUDIT_CATALOGUE = "i9audit/catalogue";
export const I9AUDIT_RESOLVE_FINDING = "i9audit/resolvefinding";
export const I9AUDIT_EXPORT = "i9audit/export";
export const I9AUDIT_EXPORTS = "i9audit/exports";
export const I9AUDIT_FORM_VIEW = "i9audit/formview";
